import { useEffect, useState } from 'react';
import { IMAGE_ORIENTATION_CACHE } from '../utils/variables';
import { ORIENTATION } from './useImageOrientation';

export default function useImageOrientations(urls) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!urls) return;

    urls.filter((url) => !!url).forEach((url, i) => {
      if (IMAGE_ORIENTATION_CACHE[url]) {
        setData(IMAGE_ORIENTATION_CACHE[url]);
        return;
      }

      const img = new Image();

      img.onload = () => {
        const { height, width } = img;

        const orientation = height > width ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE;

        IMAGE_ORIENTATION_CACHE[url] = { height, orientation, width };

        setData((prev) => {
          prev[i] = { height, orientation, width };

          return prev;
        });
      };

      img.src = url;
    });
  }, [urls]);

  return data;
}
